
import { mount } from '@vue/test-utils'
import Leftnav from './components/Leftnav'
console.log(Leftnav)